import { createReducer } from "@reduxjs/toolkit";
const initialState = {
    isLoading: false,
    isLoadingUpdate: false, 
    isLoadingDelete: false,
    isLoadingCreate: false,
    isLoadingBLog: false,
  };

  const BlogsReducer = createReducer(initialState, (builder) => {
    builder
      .addCase("get_all_blogs_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_all_blogs_success", (state,action) => {
        state.isLoading = false;
        state.AllBlogs = action.payload.blogs;
        state.pagination = action.payload.pagination;
        state.totalBlogs=action.payload.totalBlogs
      })
      .addCase("get_all_blogs_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Fillter_blogs_request", (state) => {
        state.isLoading = true;
      })
      .addCase("get_Fillter_blogs_success", (state,action) => {
        state.isLoading = false;
        state.FillterBlogs = action.payload.blogs;
        state.pagination = action.payload.pagination;
      })
      .addCase("get_Fillter_blogs_error", (state,action) => {
        state.isLoading = false;
        state.err = action.payload;
      })
      .addCase("get_Blog_request", (state) => {
        state.isLoadingBLog = true;
      })
      .addCase("get_Blog_success", (state,action) => {
        state.isLoadingBLog = false;
        state.BlogData = action.payload;
      })
      .addCase("get_Blog_error", (state,action) => {
        state.isLoadingBLog = false;
        state.err = action.payload;
      })
      .addCase("create_blog_request", (state) => {
        state.isLoadingCreate = true;
      })
      .addCase("create_blog_success", (state,action) => {
        state.isLoadingCreate = false;
        state.CreatedBlog = action.payload;

      })
      .addCase("create_blog_error", (state,action) => {
        state.isLoadingCreate = false;
        state.errCreate = action.payload;
      })
      .addCase("update_blog_request", (state) => {
        state.isLoadingUpdate = true;
      })
      .addCase("update_blog_success", (state,action) => {
        state.isLoadingUpdate = false;
        state.UpdatedBlog = action.payload;
      })
      .addCase("update_blog_error", (state,action) => {
        state.isLoadingUpdate = false;
        state.err = action.payload;
      })
      .addCase("delete_blog_request", (state) => {
        state.isLoadingDelete = true;
      })
      .addCase("delete_blog_success", (state,action) => {
        state.isLoadingDelete = false;
        state.DeleteMessage = action.payload;
      })
      .addCase("delete_blog_error", (state,action) => {
        state.isLoadingDelete = false;
        state.err = action.payload;
      })
      .addCase("clear_error", (state) => {
        state.err = null;
        state.DeleteMessage = null;
        state.UpdatedBlog = null;
        state.isLoadingDelete = false;
       state.isLoadingUpdate = false;
       state.isLoadingCreate = false;
       state.errCreate=false;
      

      });
      
  });

  
  export default BlogsReducer;